export default "__VITE_ASSET__DDll2i$u__"